export enum LegacySessionEventType {
	SESSION_CREATED = '1',
	SESSION_REFRESHED = '2',
	SESSION_DESTROYED = '3',
	SESSION_SERVICE_READY = '4',
	SESSION_REPOSITORY_READY = '5',
}
